var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":!_vm.value.name,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"mx-2"},'span',attrs,false),on),[_c('flag',{attrs:{"iso":_vm.value.id || _vm.value.alpha2Code || _vm.value,"squared":false}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.value.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }